import { createClient } from '@supabase/supabase-js';
import { tenantAwareFetch } from './tenant';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
  // Adds x-atrionos-hoa for Super Admin working in another association; a plain
  // fetch for everyone else (see lib/tenant.js).
  global: {
    fetch: tenantAwareFetch,
  },
});
